import { RecurringSchedule } from '../recurringPayments/recurringSchedule';
import { StreetAddress } from '../streetAddress/streetAddress';
import { TaxList } from '../ui/taxList';

export class L2L3Data {
  quantity: number | undefined;
  unitOfMeasure: string | undefined;
  shippingAndHandlingAmount: number | undefined;
  dutyAmount: number | undefined;
  taxes: TaxList[] = [];
  productCode: string | undefined;

  constructor(data: Partial<L2L3Data>) {
    this.quantity = data.quantity;
    this.unitOfMeasure = data.unitOfMeasure;
    this.shippingAndHandlingAmount = data.shippingAndHandlingAmount;
    this.dutyAmount = data.dutyAmount;
    this.taxes = data.taxes || [];
    this.productCode = data.productCode;
  }

  static createEmpty() {
    return new L2L3Data({
      quantity: 1,
      unitOfMeasure: '',
      dutyAmount: 0,
      productCode: '',
    });
  }
}
